import { render, staticRenderFns } from "./CoreCasePackageDetail.vue?vue&type=template&id=183de453&scoped=true"
import script from "./CoreCasePackageDetail.vue?vue&type=script&lang=js"
export * from "./CoreCasePackageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183de453",
  null
  
)

export default component.exports